var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 17.8091H29.0798C31.2866 17.8091 33.0765 19.7951 33.0765 21.8057C33.0765 24.0125 31.2866 25.8024 29.0798 25.8024H19.125V17.8091Z",
    stroke: "url(#paint0_linear_1146_198)",
    strokeWidth: 3.19,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 25.7778H30.5019C33.0274 25.7778 35.0625 27.5677 35.0625 29.7745C35.0625 31.9812 33.0274 33.7711 30.5019 33.7711H19.125V25.7778Z",
    stroke: "url(#paint1_linear_1146_198)",
    strokeWidth: 3.19,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0898 33.7468V37.7435",
    stroke: "url(#paint2_linear_1146_198)",
    strokeWidth: 3.19,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1094 33.7468V37.7435",
    stroke: "url(#paint3_linear_1146_198)",
    strokeWidth: 3.19,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0898 13.8125V17.8091",
    stroke: "url(#paint4_linear_1146_198)",
    strokeWidth: 3.19,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1094 13.8125V17.8091",
    stroke: "url(#paint5_linear_1146_198)",
    strokeWidth: 3.19,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.901 17.8091H15.9375",
    stroke: "url(#paint6_linear_1146_198)",
    strokeWidth: 3.19,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.901 33.7468H15.9375",
    stroke: "url(#paint7_linear_1146_198)",
    strokeWidth: 3.19,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 46.75C37.236 46.75 46.75 37.236 46.75 25.5C46.75 13.7639 37.236 4.25 25.5 4.25C13.7639 4.25 4.25 13.7639 4.25 25.5C4.25 37.236 13.7639 46.75 25.5 46.75Z",
    stroke: "url(#paint8_linear_1146_198)",
    strokeWidth: 3.19,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1146_198",
    x1: 19.125,
    y1: 21.8057,
    x2: 33.0765,
    y2: 21.8057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1146_198",
    x1: 19.125,
    y1: 29.7745,
    x2: 35.0625,
    y2: 29.7745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1146_198",
    x1: 26.0898,
    y1: 35.7451,
    x2: 27.0898,
    y2: 35.7451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1146_198",
    x1: 21.1094,
    y1: 35.7451,
    x2: 22.1094,
    y2: 35.7451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1146_198",
    x1: 26.0898,
    y1: 15.8108,
    x2: 27.0898,
    y2: 15.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1146_198",
    x1: 21.1094,
    y1: 15.8108,
    x2: 22.1094,
    y2: 15.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1146_198",
    x1: 15.9375,
    y1: 18.3091,
    x2: 22.901,
    y2: 18.3091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1146_198",
    x1: 15.9375,
    y1: 34.2468,
    x2: 22.901,
    y2: 34.2468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1146_198",
    x1: 4.25,
    y1: 25.5,
    x2: 46.75,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/Bitcoin.9aa4623c1f67c1c45c6d1ae6571ac091.svg";
export { ForwardRef as ReactComponent };